import gsap, { Power1, Power2, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export class Kv {
  constructor() {
    this.kvSection = document.querySelector('.p-index_kv')
    this.kvInner = document.querySelector('.p-index_kv__inner')
    this.gallerySection = document.querySelector('.p-index_kv__scrollwrap')
    this.galleryEl = document.querySelector('.p-index_kv__gallery')
    this.galleryPics = document.querySelectorAll('.p-index_kv__gallery [class*="__gallery__pic"]')
    this.messageSection = document.querySelector('.p-index_kv__message')
    this.messagePoints = document.querySelectorAll('.p-index_kv__message__point')
    this.messageHeading = document.querySelector('.p-index_kv__message__heading')

    this.kvFadeTargets = [
      document.querySelector('.p-index_kv__copy-slider:nth-of-type(1)'),
      document.querySelector('.p-index_kv__copy-slider:nth-of-type(2)'),
      document.querySelector('.p-index_kv__rugby'),
      document.querySelector('.p-index_kv__athlete'),
      document.querySelector('.p-index_kv__basketball'),
      document.querySelector('.p-index_kv__baseball'),
      document.querySelector('.p-index_kv__smoke.-l'),
      document.querySelector('.p-index_kv__smoke.-r'),
      document.querySelector('.p-index_kv__main'),
      document.querySelector('.p-index_kv__copy'),
      document.querySelector('.p-index_kv__bottom'),
    ].filter(Boolean)

    this.init()
  }

  init() {
    this._setupKvPin()
    this._setupGalleryAndMessage()
    this._setupMessagePoints()
  }

  _setupKvPin() {
    ScrollTrigger.create({
      trigger: this.kvSection,
      start: 'top top',
      end: '+=200%',
      pin: this.kvInner,
      pinSpacing: false,
      anticipatePin: 1,
    })

    const vh = window.innerHeight

    gsap.to(document.querySelector('.p-index_kv__rugby'), {
      opacity: 0,
      x: 100,
      duration: 0.5,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.2}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__athlete'), {
      opacity: 0,
      x: 100,
      duration: 0.6,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.25}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__basketball'), {
      opacity: 0,
      x: -100,
      duration: 0.5,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.2}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__baseball'), {
      opacity: 0,
      x: -100,
      duration: 0.6,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.25}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__smoke.-l'), {
      opacity: 0,
      duration: 0.4,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.1}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__smoke.-r'), {
      opacity: 0,
      duration: 0.4,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.1}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__main__boy img'), {
      opacity: 0,
      x: -60,
      duration: 0.6,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.5}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__main__girl img'), {
      opacity: 0,
      x: 60,
      duration: 0.6,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.55}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__copy'), {
      opacity: 0,
      duration: 0.5,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.3}`,
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(document.querySelector('.p-index_kv__bottom'), {
      opacity: 0,
      duration: 0.5,
      ease: Power2.easeOut,
      scrollTrigger: {
        trigger: this.kvSection,
        start: `+=${vh * 0.35}`,
        toggleActions: 'play none none reverse',
      },
    })
  }

  _setupGalleryAndMessage() {
    if (!this.galleryPics.length || !this.galleryEl) return

    gsap.set(this.galleryPics, {
      opacity: 0,
      scale: 1.06,
    })

    let tl = null

    ScrollTrigger.create({
      trigger: this.gallerySection,
      start: 'top top',
      endTrigger: this.messageSection,
      end: 'bottom bottom',
      pin: this.galleryEl,
      pinSpacing: false,
      onEnter: () => {
        if (tl) tl.kill()
        tl = gsap.timeline()
        this.galleryPics.forEach((pic, i) => {
          tl.to(
            pic,
            {
              opacity: 1,
              scale: 1,
              duration: 0.4,
              ease: Power2.easeOut,
            },
            i * 0.1,
          )
        })
      },
      onLeaveBack: () => {
        // スクロールを戻してgalleryより上に出たらリセット
        if (tl) {
          tl.kill()
          tl = null
        }
        gsap.to(this.galleryPics, {
          opacity: 0,
          scale: 1.08,
          duration: 0.4,
          ease: Power2.easeOut,
          stagger: 0.05,
        })
      },
    })
  }

  _setupMessagePoints() {
    this.messagePoints.forEach((point) => {
      gsap.fromTo(
        point,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: Power2.easeOut,
          scrollTrigger: {
            trigger: point,
            start: 'top 80%',
            end: 'top 50%',
            toggleActions: 'play none none reverse',
          },
        },
      )
    })

    if (!this.messageHeading) return

    const copySpans = this.messageHeading.querySelectorAll('.copy span')
    const leadText = this.messageHeading.querySelector('.lead__text')

    // if (copySpans.length) {
    //   gsap.fromTo(
    //     copySpans,
    //     { opacity: 0, y: 50, skewY: 2 },
    //     {
    //       opacity: 1,
    //       y: 0,
    //       skewY: 0,
    //       duration: 0.9,
    //       stagger: 0.1,
    //       ease: Power4.easeOut,
    //       scrollTrigger: {
    //         trigger: this.messageHeading,
    //         start: 'top 75%',
    //         toggleActions: 'play none none reverse',
    //       },
    //     }
    //   )
    // }

    if (leadText) {
      gsap.fromTo(
        leadText,
        { opacity: 0, y: 10 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: Power2.easeOut,
          scrollTrigger: {
            trigger: leadText,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        },
      )
    }
  }
}
